<template>
    <app-stepper-section label="">

        <vue-tags-input
            v-model="tag"
            :add-only-from-autocomplete="true"
            :tags="tags"
            class="tag"

            placeholder="Tags"
            :autocomplete-items="filteredItems"
            @tags-changed="newTags => tags = newTags"/>

    </app-stepper-section>
</template>

<script>
    import AppStepperSection from '../../../StepperSection'
    import VueTagsInput from '@johmun/vue-tags-input';

    export default {
        components: {
            AppStepperSection,
            VueTagsInput,
        },

        props: {
            label: {
                type: String,
                required: true
            },

            value: {
                type: Object,
            },
        },
        data() {
            return {
                tag: '',
                autocompleteItems: [],
            };
        },
        async mounted() {
            this.autocompleteItems = []
            let items =  await this.$api.tag.listAll()
            items.forEach(item =>{
                this.autocompleteItems.push({id : item.id, text : item.descricao})
            })
        },
        computed: {
            tags: {
                get() {
                    return this.value.tags
                },

                set(tags) {
                    this.$emit('input', {...this.value, tags})
                }
            },
            filteredItems() {
                return this.autocompleteItems.filter(i => {
                    return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
                });
            },
        },
    }
</script>

<style lang="scss" scoped>

    .tag{
        width: 100%;
        max-width: 2000px;
        text-align: left !important;
    }

</style>
